import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=55a4e066&scoped=true"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"
import style0 from "./Affiliates.vue?vue&type=style&index=0&id=55a4e066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4e066",
  null
  
)

export default component.exports